'use client';

import React from 'react';

import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import CommentWithReplies from './CommentWithReplies';
import Button from '../Button';
import { useCommentsSectionContext } from '@/ui/containers/CommentsSection/CommentsSectionContext';

const NoComments = styled.div`
  text-align: center;
  padding: 2.5rem;
  font-size: 1.25rem;
  font-weight: bold;
  color: ${({ theme }) => theme.custom.colors.gray500};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;

const Thread = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.custom.colors.gray200};
  padding-bottom: 2.5rem;
`;

export default function Comments() {
  const translate = useTranslations();
  const { comments } = useCommentsSectionContext();
  const [displayCommentsCount, setDisplayCommentsCount] = React.useState(5);

  const commentsToDisplay = React.useMemo(() => {
    if (!comments?.length) {
      return [];
    }

    return comments.slice(0, displayCommentsCount);
  }, [comments, displayCommentsCount]);

  if (!comments?.length) {
    return <NoComments>{translate('comments-noComment')}</NoComments>;
  }

  return (
    <Wrapper>
      {commentsToDisplay.map(comment => (
        <Thread key={comment.id}>
          <CommentWithReplies {...comment} />
        </Thread>
      ))}
      {comments.length > displayCommentsCount && (
        <Button
          onClick={() => setDisplayCommentsCount(displayCommentsCount + 10)}
        >
          {translate('comments-showMore')}
        </Button>
      )}
    </Wrapper>
  );
}
